<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="chat-container full-height">
    <!-- <el-tag v-if="chatDirectInfo && chatDirectInfo.length > 0" type="danger"
      >未讀{{ chatDirectInfo[0].notReadCount }}</el-tag
    > -->
    <!-- mobile -->
    <el-dialog
      v-if="device == 'mobile' && (toUser || groupToUser || panel === 'discussionChat')"
      :title="panel === 'chat' ? '聊天訊息' : panel === 'groupChat' ? '群組聊天' : '討論區'"
      :visible.sync="dialogMessageVisible"
      fullscreen
      v-loading="chatLoading || discussionChatLoading"
      class="messageDialog"
      @closed="obDialogClosed()"
    >
      <el-card
        class="box-card el-card-define chat-window full-height"
        :body-style="{ height: '88%', 'overflow-y': 'scroll' }"
      >
        <div slot="header" class="clearfix" v-if="panel === 'chat'">
          <span>{{ formatShowUserName(toUser.userName) }}</span>
        </div>
        <div slot="header" class="clearfix" v-if="panel === 'groupChat'">
          <span>{{ formatShowUserName(groupToUser.userName) }}</span>
          <div style="float: right">
            <span style="margin-right: 8px; font-size: 12px; color: red"
              >若關閉此團所有人皆無法使用群組聊天功能</span
            >
            <span
              style="margin-right: 8px; font-size: 14px"
              :style="{ color: groupToUser.openGroupChat ? '#000' : '#409EFF' }"
              >關</span
            >
            <el-switch
              v-model="groupToUser.openGroupChat"
              :disabled="switchLoading"
              @change="handleOpenGroupChatChange"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
            <span
              style="margin-left: 8px; font-size: 14px"
              :style="{ color: groupToUser.openGroupChat ? '#409EFF' : '#000' }"
              >開</span
            >
          </div>
        </div>
        <div slot="header" class="clearfix" v-if="panel === 'discussionChat'">
          <span
            >所有APP使用者在活動結束後皆會自動加入討論區
            (團體管理/其他設定/顯示資訊，設定"隱藏"則不會加入)</span
          >
          <div style="float: right">
            <span style="margin-right: 8px; font-size: 12px; color: red"
              >※點擊旅客姓名可將他移除本討論區</span
            >
            <span style="margin-right: 8px; font-size: 12px; color: red"
              >若關閉此功能所有人皆無法使用討論區聊天功能</span
            >
            <span
              style="margin-right: 8px; font-size: 14px"
              :style="{ color: discussionChatSwitch ? '#000' : '#409EFF' }"
              >關</span
            >
            <el-switch
              v-model="discussionChatSwitch"
              :disabled="switchLoading"
              @change="handleOpenDiscussionChatChange"
              active-color="#13ce66"
              inactive-color="#ff4949"
            >
            </el-switch>
            <span
              style="margin-left: 8px; font-size: 14px"
              :style="{ color: discussionChatSwitch ? '#409EFF' : '#000' }"
              >開</span
            >
          </div>
        </div>
        <template
          v-if="
            (panel === 'chat' &&
              filtered_list.length > 0 &&
              filtered_list[0] &&
              filtered_list[0].messages &&
              filtered_list[0].messages.length > 0) ||
            (panel === 'groupChat' &&
              filtered_group_list.length > 0 &&
              filtered_group_list[0] &&
              filtered_group_list[0].messages &&
              filtered_group_list[0].messages.length > 0) ||
            (panel === 'discussionChat' &&
              discussionChatList.length > 0 &&
              discussionChatList[0] &&
              discussionChatList[0].messages &&
              discussionChatList[0].messages.length > 0)
          "
        >
          <!-- Mobile版1v1聊天區域 -->
          <div
            v-if="panel === 'chat'"
            v-for="(item, index) in filtered_list[0].messages"
            :key="'chat-' + index"
          >
            <el-row>
              <el-col :span="24">
                <div class="chat-date">
                  <el-tag>{{ item.date }}</el-tag>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                  <div
                    class="chat-container-from"
                    v-if="d.from != fromUser && d.from != groupToUser.userID"
                  >
                    <div>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-form">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          :preview-src-list="[d.fileInfo.url]"
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                        ></el-image>
                      </span>
                      <i class="time-flag"> {{ d.time }}</i>
                    </div>
                  </div>
                  <div
                    style="text-align: right"
                    class="chat-container-send"
                    v-if="d.from == fromUser || d.from == groupToUser.userID"
                  >
                    <div>
                      <i v-if="d.isRead" class="read-flag">已讀</i>
                      <i class="time-flag">{{ d.time }}</i>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-send">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                          :preview-src-list="[d.fileInfo.url]"
                        ></el-image>
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- Mobile版群組聊天區域 -->
          <div
            v-if="panel === 'groupChat'"
            v-for="(item, index) in filtered_group_list[0].messages"
            :key="'group-' + index"
          >
            <el-row>
              <el-col :span="24">
                <div class="chat-date">
                  <el-tag>{{ item.date }}</el-tag>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                  <div
                    class="chat-container-from"
                    v-if="d.from != fromUser && d.from != groupToUser.userID"
                  >
                    <div>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-form">
                        {{ d.from }}：{{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <span class="chat-content-form"> {{ d.from }}： </span>
                        <!-- <div style="margin-bottom: 5px; color: #42443f">{{ d.from }}：</div> -->
                        <el-image
                          :preview-src-list="[d.fileInfo.url]"
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                        ></el-image>
                      </span>
                      <span v-if="d.chatType == 4">
                        <span class="chat-content-form"> {{ d.from }}： </span>
                        <!-- <div style="margin-bottom: 5px; color: #42443f">{{ d.from }}：</div> -->
                        <!-- <el-image
                          style="width: 100px; height: 100px"
                          :src="d.msg"
                          :fit="'cover'"
                          :preview-src-list="[d.msg]"
                        ></el-image> -->
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                          :fit="'cover'"
                          :preview-src-list="[
                            'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                          ]"
                        ></el-image>
                      </span>
                      <i class="time-flag"> {{ d.time }}</i>
                    </div>
                  </div>
                  <div
                    style="text-align: right"
                    class="chat-container-send"
                    v-if="d.from == fromUser || d.from == groupToUser.userID"
                  >
                    <div>
                      <i v-if="d.isRead" class="read-flag">已讀</i>
                      <i class="time-flag">{{ d.time }}</i>
                      <span v-if="d.chatType == 1" :closable="false" class="chat-content-send">
                        {{ d.msg }}
                      </span>
                      <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="d.fileInfo.url"
                          :fit="'cover'"
                          :preview-src-list="[d.fileInfo.url]"
                        ></el-image>
                      </span>
                      <span v-if="d.chatType == 4">
                        <!-- <l-image
                          estyle="width: 100px; height: 100px"
                          :src="d.msg"
                          :fit="'cover'"
                          :preview-src-list="[d.msg]"
                        ></el-image> -->
                        <el-image
                          style="width: 100px; height: 100px"
                          :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                          :fit="'cover'"
                          :preview-src-list="[
                            'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                          ]"
                        ></el-image>
                      </span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- Mobile版討論區聊天區域 20250805 -->
          <div
            v-if="
              panel === 'discussionChat' &&
              discussionChatList.length > 0 &&
              discussionChatList[0] &&
              discussionChatList[0].messages
            "
            v-for="(item, index) in discussionChatList[0].messages"
            :key="'discussion-' + index"
          >
            <el-row>
              <el-col :span="24">
                <div class="chat-date">
                  <el-tag>{{ item.date }}</el-tag>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                  <!-- 系統訊息 chatType == 5 置中顯示 -->
                  <div v-if="d.chatType == 5" class="chat-date">
                    <el-tag type="danger" effect="light">{{ d.msg }}</el-tag>
                  </div>
                  <!-- 一般訊息 -->
                  <template v-else>
                    <div
                      class="chat-container-from"
                      v-if="d.from != fromUser && d.from != groupToUser.userID"
                      @contextmenu.prevent="showDiscussionContextMenu($event, d)"
                      @click="showDiscussionContextMenu($event, d)"
                    >
                      <div>
                        <span v-if="d.chatType == 1" :closable="false" class="chat-content-form">
                          {{ d.fromName }}：{{ d.msg }}
                        </span>
                        <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                          <span class="chat-content-form"> {{ d.fromName }}： </span>
                          <el-image
                            :preview-src-list="[d.fileInfo.url]"
                            style="width: 100px; height: 100px"
                            :src="d.fileInfo.url"
                            :fit="'cover'"
                          ></el-image>
                        </span>
                        <span v-if="d.chatType == 4">
                          <span class="chat-content-form"> {{ d.fromName }}： </span>
                          <el-image
                            style="width: 100px; height: 100px"
                            :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                            :fit="'cover'"
                            :preview-src-list="[
                              'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                            ]"
                          ></el-image>
                        </span>
                        <i class="time-flag"> {{ d.time }}</i>
                      </div>
                    </div>
                    <div
                      style="text-align: right"
                      class="chat-container-send"
                      v-if="d.from == fromUser || d.from == groupToUser.userID"
                    >
                      <div>
                        <i v-if="d.isRead" class="read-flag">已讀</i>
                        <i class="time-flag">{{ d.time }}</i>
                        <span v-if="d.chatType == 1" :closable="false" class="chat-content-send">
                          {{ d.msg }}
                        </span>
                        <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                          <el-image
                            style="width: 100px; height: 100px"
                            :src="d.fileInfo.url"
                            :fit="'cover'"
                            :preview-src-list="[d.fileInfo.url]"
                          ></el-image>
                        </span>
                        <span v-if="d.chatType == 4">
                          <el-image
                            style="width: 100px; height: 100px"
                            :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                            :fit="'cover'"
                            :preview-src-list="[
                              'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                            ]"
                          ></el-image>
                        </span>
                      </div>
                    </div>
                  </template>
                </div>
              </el-col>
            </el-row>
          </div>
        </template>
      </el-card>
      <el-input
        v-if="panel === 'chat'"
        :disabled="chatLoading"
        style="width: 100%"
        v-model="msg"
        placeholder="請輸入內容"
        @keyup.enter.native="sendMsg"
      >
        <template slot="prepend">
          <Upload
            ref="uploadMobileChatRef"
            :accept="'.img,.jpg,.png,.jpeg,.bmp'"
            :payload="{ from: fromUser, to: toUser ? toUser.userAccount : '' }"
            :data-obj="fileObj"
            :limit-file-count="20"
            :use-drag="false"
            :action="'Chat'"
            :auto-upload="true"
            :show-file-list="false"
            :btn-txt="'上傳'"
            :before-file-list="[]"
            :show-limit="false"
            :sendFileMsgCallback="sendFileMsg"
          />
        </template>
        <template slot="append">
          <el-button
            :disabled="chatLoading"
            icon="el-icon-s-promotion"
            type="success"
            @click="sendMsg"
          />
        </template>
      </el-input>
      <el-input
        v-if="panel === 'groupChat'"
        :disabled="chatLoading || !groupToUser.openGroupChat"
        style="width: 100%"
        v-model="groupMsg"
        placeholder="請輸入群組訊息"
        class="group-sticker-input"
        @keyup.enter.native="sendMsg"
      >
        <template slot="prepend">
          <Upload
            ref="uploadMobileGroupRef"
            :accept="'.img,.jpg,.png,.jpeg,.bmp'"
            :payload="{ from: fromUser, to: groupToUser ? groupToUser.userID : '' }"
            :data-obj="fileObj"
            :limit-file-count="20"
            :use-drag="false"
            :action="'Chat'"
            :auto-upload="true"
            :show-file-list="false"
            :btn-txt="'上傳'"
            :before-file-list="[]"
            :show-limit="false"
            :sendFileMsgCallback="sendFileMsg"
          />
        </template>
        <template slot="append">
          <el-popover
            v-model="stickerPopoverVisible"
            :disabled="chatLoading || !groupToUser.openGroupChat"
            placement="top-end"
            trigger="click"
            width="540"
            popper-class="sticker-popover"
          >
            <div class="sticker-panel">
              <div class="sticker-grid">
                <img
                  v-for="sticker in stickerGroups[stickerActiveGroup - 1]"
                  :key="sticker.name"
                  :src="sticker.url"
                  class="sticker-item"
                  loading="lazy"
                  @click="sendSticker(sticker)"
                />
              </div>
              <div class="sticker-group-tabs">
                <span
                  v-for="groupIndex in 4"
                  :key="groupIndex"
                  class="sticker-group-tab"
                  :class="{ 'is-active': stickerActiveGroup === groupIndex }"
                  @click="stickerActiveGroup = groupIndex"
                  >{{ groupIndex }}</span
                >
              </div>
            </div>
            <span
              slot="reference"
              class="sticker-trigger-btn"
              :class="{ 'is-disabled': chatLoading || !groupToUser.openGroupChat }"
            >
              <img :src="smileIcon" class="sticker-trigger-icon" />
            </span>
          </el-popover>
          <el-button
            :disabled="chatLoading || !groupToUser.openGroupChat"
            icon="el-icon-s-promotion"
            type="success"
            @click="sendMsg"
          />
        </template>
      </el-input>
      <el-input
        v-if="panel === 'discussionChat'"
        :disabled="discussionChatLoading || !discussionChatSwitch"
        style="width: 100%"
        v-model="discussionMsg"
        placeholder="請輸入討論內容"
        class="discussion-sticker-input"
        @keyup.enter.native="sendMsg"
      >
        <template slot="prepend">
          <Upload
            ref="uploadMobileDiscussionRef"
            :accept="'.img,.jpg,.png,.jpeg,.bmp'"
            :payload="{ from: fromUser, to: discussionChatConnection }"
            :data-obj="fileObj"
            :limit-file-count="20"
            :use-drag="false"
            :action="'Chat'"
            :auto-upload="true"
            :show-file-list="false"
            :btn-txt="'上傳'"
            :before-file-list="[]"
            :show-limit="false"
            :sendFileMsgCallback="sendFileMsg"
          />
        </template>
        <template slot="append">
          <el-popover
            v-model="discussionStickerPopoverVisible"
            :disabled="discussionChatLoading || !discussionChatSwitch"
            placement="top-end"
            trigger="click"
            width="540"
            popper-class="sticker-popover"
          >
            <div class="sticker-panel">
              <div class="sticker-grid">
                <img
                  v-for="sticker in stickerGroups[stickerActiveGroup - 1]"
                  :key="sticker.name"
                  :src="sticker.url"
                  class="sticker-item"
                  loading="lazy"
                  @click="sendDiscussionSticker(sticker)"
                />
              </div>
              <div class="sticker-group-tabs">
                <span
                  v-for="groupIndex in 4"
                  :key="groupIndex"
                  class="sticker-group-tab"
                  :class="{ 'is-active': stickerActiveGroup === groupIndex }"
                  @click="stickerActiveGroup = groupIndex"
                  >{{ groupIndex }}</span
                >
              </div>
            </div>
            <span
              slot="reference"
              class="sticker-trigger-btn"
              :class="{ 'is-disabled': discussionChatLoading || !discussionChatSwitch }"
            >
              <img :src="smileIcon" class="sticker-trigger-icon" />
            </span>
          </el-popover>
          <el-button
            :disabled="discussionChatLoading || !discussionChatSwitch"
            icon="el-icon-s-promotion"
            type="success"
            @click="sendMsg"
          />
        </template>
      </el-input>
    </el-dialog>

    <el-tabs v-model="panel" type="border-card" class="full-height">
      <el-tab-pane label="團體群聊" name="groupChat" class="full-height">
        <el-row class="row-box full-height">
          <el-col
            class="full-height"
            v-loading="listLoading || createLoading"
            :xs="24"
            :sm="24"
            :md="9"
            :lg="9"
            :xl="9"
          >
            <el-card class="box-card el-card-define full-height" :body-style="{ height: '100%' }">
              <div v-if="groupChatDirectInfo && groupChatDirectInfo.length > 0" class="full-height">
                <el-table height="100%" :data="groupChatDirectInfo" style="width: 100%" size="mini">
                  <el-table-column width="50">
                    <template slot-scope="scope">
                      <el-avatar
                        shape="square"
                        size="large"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                        @click="selectedGroup(scope.row.from)"
                        style="cursor: pointer"
                      ></el-avatar>
                    </template>
                  </el-table-column>

                  <el-table-column prop="fromUserName" style="width: 100%">
                    <template slot-scope="scope">
                      <span @click="selectedGroup(scope.row.from)" style="cursor: pointer">
                        {{ formatShowUserName(scope.row.fromUserName) }}
                        <el-alert
                          v-if="scope.row.messages && scope.row.messages.msg"
                          :closable="false"
                          :title="cutText(scope.row.messages.msg)"
                          type="info"
                        />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="60">
                    <template slot-scope="scope">
                      <i v-if="scope.row.messages && scope.row.messages.time" style="color: #ccc">{{
                        scope.row.messages.time
                      }}</i>
                      <el-tag v-if="scope.row.notReadCount > 0" type="danger">{{
                        scope.row.notReadCount
                      }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>

          <el-col
            v-if="
              device == 'desktop' &&
              panel === 'groupChat' &&
              groupToUser !== undefined &&
              groupToUser.userAccount
            "
            class="full-height hidden-xs-only"
            v-loading="chatLoading"
            :span="14"
            :offset="1"
            style="position: relative; height: 92%"
          >
            <el-card
              class="box-card el-card-define chat-window full-height"
              :body-style="{ height: '92%', 'overflow-y': 'scroll' }"
            >
              <div slot="header" class="clearfix">
                <span>{{ formatShowUserName(groupToUser.userName) }}</span>
                <div style="float: right">
                  <span style="margin-right: 8px; font-size: 12px; color: red"
                    >若關閉此團所有人皆無法使用群組聊天功能</span
                  >
                  <span
                    style="margin-right: 8px; font-size: 14px"
                    :style="{ color: groupToUser.openGroupChat ? '#000' : '#409EFF' }"
                    >關</span
                  >
                  <el-switch
                    v-model="groupToUser.openGroupChat"
                    :disabled="switchLoading"
                    @change="handleOpenGroupChatChange"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                  <span
                    style="margin-left: 8px; font-size: 14px"
                    :style="{ color: groupToUser.openGroupChat ? '#409EFF' : '#000' }"
                    >開</span
                  >
                </div>
              </div>
              <template
                v-if="
                  panel === 'groupChat' &&
                  filtered_group_list.length > 0 &&
                  filtered_group_list[0] &&
                  filtered_group_list[0].messages &&
                  filtered_group_list[0].messages.length > 0
                "
              >
                <div v-for="(item, index) in filtered_group_list[0].messages" :key="index">
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-date">
                        <el-tag>{{ item.date }}</el-tag>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                        <div
                          class="chat-container-from"
                          v-if="d.from != fromUser && d.from != groupToUser.userID"
                        >
                          <div>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-form"
                            >
                              {{ d.from }}：{{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <span class="chat-content-form"> {{ d.from }}： </span>
                              <!-- <div style="margin-bottom: 5px">{{ d.from }}：</div> -->
                              <el-image
                                :preview-src-list="[d.fileInfo.url]"
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                              ></el-image>
                            </span>
                            <span v-if="d.chatType == 4">
                              <span class="chat-content-form"> {{ d.from }}： </span>
                              <!-- <div style="margin-bottom: 5px">{{ d.from }}：</div> -->
                              <!-- <el-image
                                style="width: 100px; height: 100px"
                                :src="d.msg"
                                :fit="'cover'"
                                :preview-src-list="[d.msg]"
                              ></el-image> -->
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                                :fit="'cover'"
                                :preview-src-list="[
                                  'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                                ]"
                              ></el-image>
                            </span>
                            <i class="time-flag"> {{ d.time }}</i>
                          </div>
                        </div>
                        <div
                          style="text-align: right"
                          class="chat-container-send"
                          v-if="d.from == fromUser || d.from == groupToUser.userID"
                        >
                          <div>
                            <i v-if="d.isRead" class="read-flag">已讀</i>
                            <i class="time-flag">{{ d.time }}</i>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-send"
                            >
                              {{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                                :preview-src-list="[d.fileInfo.url]"
                              ></el-image>
                            </span>
                            <span v-if="d.chatType == 4">
                              <!-- <el-image
                                style="width: 100px; height: 100px"
                                :src="d.msg"
                                :fit="'cover'"
                                :preview-src-list="[d.msg]"
                              ></el-image> -->
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                                :fit="'cover'"
                                :preview-src-list="[
                                  'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                                ]"
                              ></el-image>
                            </span>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-card>
            <el-input
              v-if="panel === 'groupChat'"
              :disabled="chatLoading || !groupToUser.openGroupChat"
              style="width: 100%"
              v-model="groupMsg"
              placeholder="請輸入內容"
              class="group-sticker-input"
              @keyup.enter.native="sendMsg"
            >
              <template slot="prepend">
                <Upload
                  ref="uploadDesktopGroupRef"
                  :accept="'.img,.jpg,.png,.jpeg,.bmp'"
                  :payload="{ from: fromUser, to: groupToUser ? groupToUser.userID : '' }"
                  :data-obj="fileObj"
                  :limit-file-count="20"
                  :use-drag="false"
                  :action="'Chat'"
                  :auto-upload="true"
                  :show-file-list="false"
                  :multiple="false"
                  :btn-txt="'上傳'"
                  :before-file-list="[]"
                  :show-limit="false"
                  :sendFileMsgCallback="sendFileMsg"
                />
              </template>
              <template slot="append">
                <el-popover
                  v-model="stickerPopoverVisible"
                  :disabled="chatLoading || !groupToUser.openGroupChat"
                  placement="top-end"
                  trigger="click"
                  width="540"
                  popper-class="sticker-popover"
                >
                  <div class="sticker-panel">
                    <div class="sticker-grid">
                      <img
                        v-for="sticker in stickerGroups[stickerActiveGroup - 1]"
                        :key="sticker.name"
                        :src="sticker.url"
                        class="sticker-item"
                        loading="lazy"
                        @click="sendSticker(sticker)"
                      />
                    </div>
                    <div class="sticker-group-tabs">
                      <span
                        v-for="groupIndex in 4"
                        :key="groupIndex"
                        class="sticker-group-tab"
                        :class="{ 'is-active': stickerActiveGroup === groupIndex }"
                        @click="stickerActiveGroup = groupIndex"
                        >{{ groupIndex }}</span
                      >
                    </div>
                  </div>
                  <span
                    slot="reference"
                    class="sticker-trigger-btn"
                    :class="{ 'is-disabled': chatLoading || !groupToUser.openGroupChat }"
                  >
                    <img :src="smileIcon" class="sticker-trigger-icon" />
                  </span>
                </el-popover>
                <el-button
                  :disabled="chatLoading || !groupToUser.openGroupChat"
                  icon="el-icon-s-promotion"
                  type="success"
                  @click="sendMsg"
                />
              </template>
            </el-input>
          </el-col>
        </el-row>
      </el-tab-pane>
      <!-- 討論區分頁 20250805 -->
      <el-tab-pane
        v-if="envMode != 'production'"
        label="討論區"
        name="discussionChat"
        class="full-height"
      >
        <el-row class="row-box full-height">
          <el-col
            class="full-height"
            v-loading="discussionChatLoading"
            :span="24"
            style="position: relative; height: 92%"
          >
            <el-card
              class="box-card el-card-define chat-window full-height"
              :body-style="{ height: '92%', 'overflow-y': 'scroll' }"
            >
              <div slot="header" class="clearfix">
                <span
                  >所有APP使用者在活動結束後皆會自動加入討論區
                  (團體管理/其他設定/顯示資訊，設定"隱藏"則不會加入)</span
                >
                <div style="float: right">
                  <span style="margin-right: 8px; font-size: 12px; color: red"
                    >※點擊旅客姓名可將他移除本討論區</span
                  >
                  <span style="margin-right: 8px; font-size: 12px; color: red"
                    >若關閉此功能所有人皆無法使用討論區聊天功能</span
                  >
                  <span
                    style="margin-right: 8px; font-size: 14px"
                    :style="{ color: discussionChatSwitch ? '#000' : '#409EFF' }"
                    >關</span
                  >
                  <el-switch
                    v-model="discussionChatSwitch"
                    :disabled="switchLoading"
                    @change="handleOpenDiscussionChatChange"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                  >
                  </el-switch>
                  <span
                    style="margin-left: 8px; font-size: 14px"
                    :style="{ color: discussionChatSwitch ? '#409EFF' : '#000' }"
                    >開</span
                  >
                </div>
              </div>
              <template
                v-if="
                  discussionChatList.length > 0 &&
                  discussionChatList[0] &&
                  discussionChatList[0].messages &&
                  discussionChatList[0].messages.length > 0
                "
              >
                <div
                  v-for="(item, index) in discussionChatList[0].messages"
                  :key="'discussion-' + index"
                >
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-date">
                        <el-tag>{{ item.date }}</el-tag>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                        <!-- 系統訊息 chatType == 5 置中顯示 -->
                        <div v-if="d.chatType == 5" class="chat-date">
                          <el-tag type="danger" effect="light">{{ d.msg }}</el-tag>
                        </div>
                        <!-- 一般訊息 -->
                        <template v-else>
                          <div
                            class="chat-container-from"
                            v-if="d.from != fromUser && d.from != groupToUser.userID"
                            @contextmenu.prevent="showDiscussionContextMenu($event, d)"
                            @click="showDiscussionContextMenu($event, d)"
                          >
                            <div>
                              <span
                                v-if="d.chatType == 1"
                                :closable="false"
                                class="chat-content-form"
                              >
                                {{ d.fromName }}：{{ d.msg }}
                              </span>
                              <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                                <span class="chat-content-form"> {{ d.fromName }}： </span>
                                <el-image
                                  :preview-src-list="[d.fileInfo.url]"
                                  style="width: 100px; height: 100px"
                                  :src="d.fileInfo.url"
                                  :fit="'cover'"
                                ></el-image>
                              </span>
                              <span v-if="d.chatType == 4">
                                <span class="chat-content-form"> {{ d.fromName }}： </span>
                                <el-image
                                  style="width: 100px; height: 100px"
                                  :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                                  :fit="'cover'"
                                  :preview-src-list="[
                                    'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                                  ]"
                                ></el-image>
                              </span>
                              <i class="time-flag"> {{ d.time }}</i>
                            </div>
                          </div>
                          <div
                            style="text-align: right"
                            class="chat-container-send"
                            v-if="d.from == fromUser || d.from == groupToUser.userID"
                          >
                            <div>
                              <i v-if="d.isRead" class="read-flag">已讀</i>
                              <i class="time-flag">{{ d.time }}</i>
                              <span
                                v-if="d.chatType == 1"
                                :closable="false"
                                class="chat-content-send"
                              >
                                {{ d.msg }}
                              </span>
                              <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                                <el-image
                                  style="width: 100px; height: 100px"
                                  :src="d.fileInfo.url"
                                  :fit="'cover'"
                                  :preview-src-list="[d.fileInfo.url]"
                                ></el-image>
                              </span>
                              <span v-if="d.chatType == 4">
                                <el-image
                                  style="width: 100px; height: 100px"
                                  :src="'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png'"
                                  :fit="'cover'"
                                  :preview-src-list="[
                                    'https://itainctwbucket.s3.ap-northeast-1.amazonaws.com/files/imageFile/icons8-smile-100.png',
                                  ]"
                                ></el-image>
                              </span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-card>
            <el-input
              :disabled="discussionChatLoading || !discussionChatSwitch"
              style="width: 100%"
              v-model="discussionMsg"
              placeholder="請輸入討論內容"
              class="discussion-sticker-input"
              @keyup.enter.native="sendMsg"
            >
              <template slot="prepend">
                <Upload
                  ref="uploadDiscussionRef"
                  :accept="'.img,.jpg,.png,.jpeg,.bmp'"
                  :payload="{ from: fromUser, to: discussionChatConnection }"
                  :data-obj="fileObj"
                  :limit-file-count="20"
                  :use-drag="false"
                  :action="'Chat'"
                  :auto-upload="true"
                  :show-file-list="false"
                  :multiple="false"
                  :btn-txt="'上傳'"
                  :before-file-list="[]"
                  :show-limit="false"
                  :sendFileMsgCallback="sendFileMsg"
                />
              </template>
              <template slot="append">
                <el-popover
                  v-model="discussionStickerPopoverVisible"
                  :disabled="discussionChatLoading || !discussionChatSwitch"
                  placement="top-end"
                  trigger="click"
                  width="540"
                  popper-class="sticker-popover"
                >
                  <div class="sticker-panel">
                    <div class="sticker-grid">
                      <img
                        v-for="sticker in stickerGroups[stickerActiveGroup - 1]"
                        :key="sticker.name"
                        :src="sticker.url"
                        class="sticker-item"
                        loading="lazy"
                        @click="sendDiscussionSticker(sticker)"
                      />
                    </div>
                    <div class="sticker-group-tabs">
                      <span
                        v-for="groupIndex in 4"
                        :key="groupIndex"
                        class="sticker-group-tab"
                        :class="{ 'is-active': stickerActiveGroup === groupIndex }"
                        @click="stickerActiveGroup = groupIndex"
                        >{{ groupIndex }}</span
                      >
                    </div>
                  </div>
                  <span
                    slot="reference"
                    class="sticker-trigger-btn"
                    :class="{ 'is-disabled': discussionChatLoading || !discussionChatSwitch }"
                  >
                    <img :src="smileIcon" class="sticker-trigger-icon" />
                  </span>
                </el-popover>
                <el-button
                  :disabled="discussionChatLoading || !discussionChatSwitch"
                  icon="el-icon-s-promotion"
                  type="success"
                  @click="sendMsg"
                />
              </template>
            </el-input>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="智遊旅程對話" name="chat" class="full-height">
        <el-row class="row-box full-height">
          <!-- <el-col
            v-loading="listLoading || createLoading"
            :sm="13"
            :md="9"
            :lg="9"
            :xl="9"
            class="full-height hidden-xs-only"
          > -->
          <el-col
            class="full-height"
            v-loading="listLoading || createLoading"
            :xs="24"
            :sm="24"
            :md="9"
            :lg="9"
            :xl="9"
          >
            <el-card class="box-card el-card-define full-height" :body-style="{ height: '100%' }">
              <div v-if="chatDirectInfo && chatDirectInfo.length > 0" class="full-height">
                <el-table height="100%" :data="chatDirectInfo" style="width: 100%" size="mini">
                  <el-table-column width="50">
                    <template slot-scope="scope">
                      <el-avatar
                        shape="square"
                        size="large"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                        @click="selectedUser(scope.row.from)"
                        style="cursor: pointer"
                      ></el-avatar>
                    </template>
                  </el-table-column>

                  <el-table-column prop="fromUserName" style="width: 100%">
                    <template slot-scope="scope">
                      <span @click="selectedUser(scope.row.from)" style="cursor: pointer">
                        {{ formatShowUserName(scope.row.fromUserName) }}
                        <el-alert
                          v-if="scope.row.messages && scope.row.messages.msg"
                          :closable="false"
                          :title="cutText(scope.row.messages.msg)"
                          type="info"
                        />
                      </span>
                    </template>
                  </el-table-column>

                  <el-table-column width="60">
                    <template slot-scope="scope">
                      <!-- <el-tag v-if="scope.row.notReadCount > 0" type="danger">{{
                        scope.row.notReadCount
                      }}</el-tag> -->
                      <i v-if="scope.row.messages && scope.row.messages.time" style="color: #ccc">{{
                        scope.row.messages.time
                      }}</i>
                      <el-tag v-if="scope.row.notReadCount > 0" type="danger">{{
                        scope.row.notReadCount
                      }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>

          <el-col
            v-if="device == 'desktop' && toUser !== undefined && toUser.userAccount"
            class="full-height hidden-xs-only"
            v-loading="chatLoading"
            :span="14"
            :offset="1"
            style="position: relative; height: 92%"
          >
            <el-card
              class="box-card el-card-define chat-window full-height"
              :body-style="{ height: '92%', 'overflow-y': 'scroll' }"
            >
              <div slot="header" class="clearfix">
                <span>{{ formatShowUserName(toUser.userName) }}</span>
              </div>
              <template
                v-if="
                  panel === 'chat' &&
                  filtered_list.length > 0 &&
                  filtered_list[0].messages &&
                  filtered_list[0].messages.length > 0
                "
              >
                <div v-for="(item, index) in filtered_list[0].messages" :key="index">
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-date">
                        <el-tag>{{ item.date }}</el-tag>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="chat-receive" v-for="(d, ind) in item.charMsgInfos" :key="ind">
                        <div class="chat-container-from" v-if="d.from != fromUser">
                          <div>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-form"
                            >
                              {{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                :preview-src-list="[d.fileInfo.url]"
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                              ></el-image>
                            </span>
                            <i class="time-flag"> {{ d.time }}</i>
                          </div>
                        </div>
                        <div
                          style="text-align: right"
                          class="chat-container-send"
                          v-if="d.from == fromUser"
                        >
                          <div>
                            <i v-if="d.isRead" class="read-flag">已讀</i>
                            <i class="time-flag">{{ d.time }}</i>
                            <span
                              v-if="d.chatType == 1"
                              :closable="false"
                              class="chat-content-send"
                            >
                              {{ d.msg }}
                            </span>
                            <span v-if="d.chatType == 2 && d.fileInfo && d.fileInfo.url">
                              <el-image
                                style="width: 100px; height: 100px"
                                :src="d.fileInfo.url"
                                :fit="'cover'"
                                :preview-src-list="[d.fileInfo.url]"
                              ></el-image>
                            </span>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </template>
            </el-card>
            <el-input
              v-if="panel === 'chat'"
              :disabled="chatLoading"
              style="width: 100%"
              v-model="msg"
              placeholder="請輸入內容"
              @keyup.enter.native="sendMsg"
            >
              <!-- <el-button
                :disabled="chatLoading"
                slot="prepend"
                type="success"
                icon="el-icon-plus"
              ></el-button> -->
              <template slot="prepend">
                <Upload
                  ref="uploadDesktopChatRef"
                  :accept="'.img,.jpg,.png,.jpeg,.bmp'"
                  :payload="{ from: fromUser, to: toUser.userAccount }"
                  :data-obj="fileObj"
                  :limit-file-count="20"
                  :use-drag="false"
                  :action="'Chat'"
                  :auto-upload="true"
                  :show-file-list="false"
                  :multiple="false"
                  :btn-txt="'上傳'"
                  :before-file-list="[]"
                  :show-limit="false"
                  :sendFileMsgCallback="sendFileMsg"
                />
              </template>
              <template slot="append">
                <el-button
                  :disabled="chatLoading"
                  icon="el-icon-s-promotion"
                  type="success"
                  @click="sendMsg"
                />
              </template>
            </el-input>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="好友列表" name="userList" class="full-height">
        <el-row class="row-box full-height">
          <el-col v-loading="listLoading" :span="6" class="full-height" :xs="24">
            <el-card class="box-card el-card-define full-height" :body-style="{ height: '100%' }">
              <div class="full-height">
                <el-table
                  @row-dblclick="rowDbClick"
                  :data="userList"
                  style="width: 100%"
                  height="100%"
                  size="mini"
                >
                  <el-table-column prop="userAccount" width="50">
                    <a @click="selectedUser(scope.row.userAccount)"
                      ><el-avatar
                        shape="square"
                        size="medium"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                      ></el-avatar
                    ></a>
                  </el-table-column>

                  <el-table-column prop="userName" style="width: 100%">
                    <template slot-scope="scope">
                      <a @click="selectedUser(scope.row.userAccount)">{{
                        formatShowUserName(scope.row.userName)
                      }}</a>
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="status" label="狀態"> </el-table-column> -->
                  <!-- <el-table-column>
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="selectedUser(scope.row.userAccount)"
                      >
                        選擇
                      </el-button>
                    </template>
                    >
                  </el-table-column> -->
                </el-table>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <!-- 討論區右鍵選單 -->
    <div
      v-if="showContextMenu"
      ref="contextMenu"
      class="context-menu"
      :style="{ left: contextMenuX + 'px', top: contextMenuY + 'px' }"
      @click.stop
    >
      <div class="context-menu-item" @click="removeFromDiscussion">移出討論區</div>
      <!-- <div class="context-menu-item" @click="addToBlacklist">黑名單</div> -->
    </div>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'

// import this.$socket from "@/utils/socket";
import { _uuid, convertFileToBase64 } from '@/utils/funcs'
import { mapGetters } from 'vuex'
import {
  markMessageAsRead,
  getDirectMessages,
  getAnUser,
  getGroupMessageList,
  getAnGroup,
  setSwitchGroupChat,
  setSwitchAgencyChat,
} from '@/api/chat'
import settings from '@/settings'

// 團體群聊貼圖：依 src/assets/texture/1~4 資料夾動態載入，共 4 組 x 9 張（排除根目錄的 smile.png 按鈕圖示）
const stickerContext = require.context('@/assets/texture', true, /\.png$/)
const STICKER_GROUPS = [1, 2, 3, 4].map(groupId => {
  const groupPrefix = `./${groupId}/`
  return stickerContext
    .keys()
    .filter(key => key.startsWith(groupPrefix))
    .sort()
    .map(key => ({
      name: key.slice(groupPrefix.length),
      url: stickerContext(key),
    }))
})

export default {
  name: 'ChatComponents',
  components: {
    Upload: () => import('@/views/ita/components/fileUpload.vue'),
  },
  props: {
    userList: {
      type: Array,
      default: () => [],
    },
    fromUser: {
      type: String,
      default: () => '',
    },
  },
  async activated() {},
  async mounted() {
    // 初始化本地討論區開關狀態
    this.localDiscussionChatSwitch = this.$store.getters.userInfo.openAgencyChat || false
    await this.pageInit()
  },
  data() {
    return {
      fileObj: { id: 0, type: 'chat', user: '' },
      createLoading: false,
      panel: '',
      listLoading: false,
      chatLoading: false,
      switchLoading: false,
      chatList: [],
      currentCharMessages: [],
      msg: '',
      toUser: {},
      msgkey: '',
      chatDirectInfo: [],
      dialogMessageVisible: false,

      // 旅行團群聊
      groupChatDirectInfo: [],
      groupMsg: '',
      groupToUser: {},
      groupChatList: [
        {
          messages: [
            {
              date: new Date().toISOString().split('T')[0],
              charMsgInfos: [],
            },
          ],
        },
      ],
      currentGroupCharMessages: [],
      selectedGroupUser: '',

      // 團體群聊貼圖功能
      smileIcon: require('@/assets/texture/smile.png'),
      stickerPopoverVisible: false,
      stickerActiveGroup: 1,
      stickerSending: false,
      discussionStickerPopoverVisible: false,

      // 討論區相關參數 20250805
      discussionChatLoading: false,
      localDiscussionChatSwitch: null, // 本地討論區開關狀態，用於處理 UI 即時反饋
      isUpdatingDiscussionSwitch: false, // 防止重複調用的標記
      discussionMsg: '',
      discussionChatConnection: '', // 固定連線格式: "AgencyChat_" + this.fromUser
      discussionChatList: [
        {
          messages: [
            {
              date: new Date().toISOString().split('T')[0],
              charMsgInfos: [],
            },
          ],
        },
      ], // 討論區對話列表
      currentDiscussionMessages: [], // 當前討論區訊息

      // 右鍵選單相關
      showContextMenu: false,
      contextMenuX: 0,
      contextMenuY: 0,
      selectedMessage: null, // 被選中的訊息
      envMode: process.env.NODE_ENV,
    }
  },
  computed: {
    ...mapGetters(['device']),
    // 獲取 agencyCode 20250805
    agencyCode() {
      return this.$store.getters.userInfo.agencyCode || ''
    },
    // 團體群聊貼圖分組（4 組 x 9 張）
    stickerGroups() {
      return STICKER_GROUPS
    },
    // 討論區開關狀態，優先使用本地狀態，否則從 store 獲取
    discussionChatSwitch: {
      get() {
        return this.localDiscussionChatSwitch !== null
          ? this.localDiscussionChatSwitch
          : this.$store.getters.userInfo.openAgencyChat || false
      },
      set(value) {
        // 防止重複調用
        if (this.isUpdatingDiscussionSwitch) {
          return
        }
        // 當 v-model 試圖設置值時，調用開關變更處理方法
        this.handleOpenDiscussionChatChange(value)
      },
    },
    filtered_list() {
      if (this.chatList && this.chatList.length > 0) {
        this.currentCharMessages = this.chatList[0].messages
        return this.chatList
      }
      // 返回一個有正確結構的預設值，避免模板中的 undefined 錯誤
      return [
        {
          messages: [],
        },
      ]
    },
    filtered_group_list() {
      if (this.groupChatList && this.groupChatList.length > 0 && this.groupChatList[0]) {
        // 確保 messages 屬性存在 20250805 修復undefined錯誤
        if (!this.groupChatList[0].messages) {
          this.groupChatList[0].messages = []
        }
        // 確保每個 message 都有正確的結構
        if (this.groupChatList[0].messages.length === 0) {
          this.groupChatList[0].messages.push({
            date: new Date().toISOString().split('T')[0],
            charMsgInfos: [],
          })
        }
        this.currentGroupCharMessages = this.groupChatList[0].messages
        return this.groupChatList
      }
      // 返回一個有正確結構的預設值，避免模板中的 undefined 錯誤
      return [
        {
          messages: [
            {
              date: new Date().toISOString().split('T')[0],
              charMsgInfos: [],
            },
          ],
        },
      ]
    },
    // 討論區過濾列表 20250805
    filtered_discussion_list() {
      if (
        this.discussionChatList &&
        this.discussionChatList.length > 0 &&
        this.discussionChatList[0]
      ) {
        // 確保 messages 屬性存在 20250805 修復undefined錯誤
        if (!this.discussionChatList[0].messages) {
          this.discussionChatList[0].messages = []
        }
        this.currentDiscussionMessages = this.discussionChatList[0].messages
        return this.discussionChatList
      }
      // 返回一個有正確結構的預設值，避免模板中的 undefined 錯誤
      return [
        {
          messages: [],
        },
      ]
    },
  },
  watch: {
    userList: {
      handler: function (newVal, oldVal) {
        const vm = this
        if (newVal.length > 0) {
          this.listLoading = false
        }
      },
      deep: true,
      immediate: true,
    },
    // 監聽面板切換 20250805
    panel: {
      handler: async function (newVal, oldVal) {
        const vm = this
        if (newVal === 'discussionChat' && oldVal !== 'discussionChat') {
          // 當切換到討論區時，確保初始化討論區
          await vm.enterDiscussion()
        }
      },
      immediate: false,
    },
    // 監聽 store 中 userInfo 的變化，同步討論區開關狀態
    '$store.getters.userInfo.openAgencyChat': {
      handler: function (newVal) {
        // 只有在不是 loading 狀態且不在更新過程中時才同步，避免在 API 調用過程中被覆蓋
        if (!this.switchLoading && !this.isUpdatingDiscussionSwitch) {
          this.localDiscussionChatSwitch = newVal || false
        }
      },
      immediate: false,
    },
  },
  async created() {
    // this.getDirectMessages ()
    // 註冊ws 監聽事件，當後端異動觸發 handleGetMessage方法
    this.$socket.$on('open', this.handleConnected)
    this.$socket.$on('message', this.handleGetMessage)
    this.$socketGroup.$on('open', this.handleConnectedGroup)
    this.$socketGroup.$on('message', this.handleGetGroupMessage)

    // 初始化討論區連線 20250805
    this.initDiscussionChat()

    await this.pageInit()
    await this.pageInitGroupChat()

    // 添加全局點擊事件監聽器來隱藏右鍵選單
    document.addEventListener('click', this.hideContextMenu)
  },
  beforeDestroy() {
    // 移除事件監聽器
    document.removeEventListener('click', this.hideContextMenu)
  },
  methods: {
    formatShowUserName(name) {
      return name === '智遊旅程行政人員' ? '智遊旅程客服人員' : name
    },
    async getAnUser(userAccount) {
      let resp = await getAnUser({ userAccount })
      return resp.data
    },
    async getAnGroup(userAccount, groupAccount) {
      let resp = await getAnGroup({ userAccount, groupAccount })
      return resp.data
    },
    async pageInit() {
      this.panel = 'chat'
      this.createLoading = true
      await this.getDirectMessages()
      this.createLoading = false
    },
    async pageInitGroupChat() {
      this.panel = 'groupChat'
      this.createLoading = true
      await this.getGroupMessageList()
      this.createLoading = false
    },
    // 初始化討論區 20250805
    initDiscussionChat() {
      // 設定討論區固定連線: "AgencyChat_" + agencyCode
      const agencyCode = this.agencyCode || 'DEFAULT'
      this.discussionChatConnection = `AgencyChat_${agencyCode}`
      console.log('討論區連線初始化:', this.discussionChatConnection)
      console.log('使用的 agencyCode:', agencyCode)

      // 如果 agencyCode 為空，延遲重新初始化
      if (!this.agencyCode) {
        console.warn('agencyCode 尚未載入，將在用戶資訊載入後重新初始化')
        setTimeout(() => {
          if (this.agencyCode) {
            const newAgencyCode = this.agencyCode
            this.discussionChatConnection = `AgencyChat_${newAgencyCode}`
            console.log('重新初始化討論區連線:', this.discussionChatConnection)
          }
        }, 1000)
      }
    },
    // 初始化討論區頁面 20250805
    async pageInitDiscussionChat() {
      this.panel = 'discussionChat'
      this.discussionChatLoading = true
      await this.getDiscussionMessageList()
      this.discussionChatLoading = false
    },
    // 取得討論區訊息列表 20250805
    async getDiscussionMessageList() {
      const vm = this
      console.log('取得討論區訊息列表 fromUser:', vm.fromUser)
      console.log('討論區連線:', vm.discussionChatConnection)

      try {
        // 標記訊息為已讀並取得完整對話紀錄
        const payload = {
          from: vm.fromUser,
          to: [vm.discussionChatConnection],
          isFromAppClient: false,
        }
        const response = await markMessageAsRead(payload)

        // response.data 為完整討論區對話紀錄，直接使用這個資料
        vm.discussionChatList = response.data || []

        // 確保資料結構正確
        if (vm.discussionChatList.length > 0) {
          if (!vm.discussionChatList[0]) {
            vm.discussionChatList[0] = { messages: [] }
          }
          if (!vm.discussionChatList[0].messages) {
            vm.discussionChatList[0].messages = []
          }
          // 如果messages是空陣列，添加今天的結構
          if (vm.discussionChatList[0].messages.length === 0) {
            const today = new Date().toISOString().split('T')[0]
            vm.discussionChatList[0].messages.push({
              date: today,
              charMsgInfos: [],
            })
            console.log('Created empty discussion message structure for today')
          }
        } else {
          // 創建預設結構避免錯誤
          vm.discussionChatList = [
            {
              messages: [
                {
                  date: new Date().toISOString().split('T')[0],
                  charMsgInfos: [],
                },
              ],
            },
          ]
        }

        console.log('討論區訊息列表載入完成:', vm.discussionChatList)
      } catch (error) {
        console.error('取得討論區訊息失敗:', error)
        // 創建預設結構避免錯誤
        vm.discussionChatList = [
          {
            messages: [
              {
                date: new Date().toISOString().split('T')[0],
                charMsgInfos: [],
              },
            ],
          },
        ]
      }
    },
    chatRowDbClick(row, column, event) {
      this.selectedUser(row.from)
    },
    rowDbClick(row, column, event) {
      this.selectedUser(row.userAccount)
    },
    handleConnected() {
      this.getDirectMessages()
      this.panel = 'chat'
    },
    handleConnectedGroup() {
      this.getGroupMessageList()
      // 只有在不是討論區時才切換到群組聊天
      if (this.panel !== 'discussionChat') {
        this.panel = 'groupChat' // 選擇了群組
      }
    },
    async getDirectMessages() {
      const vm = this
      let res = await getDirectMessages({ account: vm.fromUser })
      vm.chatDirectInfo = res.data || []

      if (vm.chatDirectInfo.length > 0) {
        let msgCountSum = vm.chatDirectInfo
          .map(item => item.notReadCount || 0)
          .reduce((prev, next) => prev + next)
        this.$store.dispatch('app/setMessage', parseInt(msgCountSum))
      } else {
        // 只有在當前面板是聊天頁面且沒有個人聊天記錄時，才切換到好友列表
        // 避免在群組聊天時被誤切換
        if (vm.panel === 'chat') {
          this.panel = 'userList'
        }
      }
    },
    async getGroupMessageList() {
      console.log('getGroupMessageList fromUser', this.fromUser)
      console.log('getGroupMessageList this.selectedGroupUser', this.selectedGroupUser)
      const vm = this
      let res = await getGroupMessageList({ account: vm.fromUser })
      vm.groupChatDirectInfo = res.data || []

      if (vm.groupChatDirectInfo.length > 0) {
        let msgCountSum = vm.groupChatDirectInfo
          .map(item => item.notReadCount || 0)
          .reduce((prev, next) => prev + next)
        this.$store.dispatch('app/setMessage', parseInt(msgCountSum))
      } else {
        this.$store.dispatch('app/setMessage', 0)
        // 注意：與 getDirectMessages 不同，這裡不要自動切換到 userList
        // 因為用戶可能正在群聊頁面，沒有群組訊息不代表要切換回好友列表
      }
    },
    async selectedUser(user) {
      const vm = this
      vm.toUser = vm.userList.filter(f => {
        return f.userAccount == user
      })[0]
      if (!vm.toUser) {
        let findUser = await vm.getAnUser(user)
        vm.toUser = findUser
      }

      if (vm.panel != 'chat') {
        vm.panel = 'chat'
      }

      if (this.device == 'mobile') {
        this.dialogMessageVisible = true
      }

      vm.chatLoading = true

      // 建立聊天室並標示訊息已讀
      const payload = { from: user, to: [vm.fromUser] }
      markMessageAsRead(payload).then(async response => {
        await this.getDirectMessages()
        //response.data 為完整對話紀錄
        vm.chatList = response.data
        vm.chatLoading = false
        // 聊天視窗向底部
        setTimeout(() => {
          vm.updateScrollTop()
        }, 500)
      })
    },
    async selectedGroup(user) {
      const vm = this
      vm.selectedGroupUser = user
      console.log('selectedGroup user', vm.selectedGroupUser)

      // 先初始化 groupChatList 避免手機模式下的渲染錯誤
      if (!vm.groupChatList || vm.groupChatList.length === 0) {
        vm.groupChatList = [
          {
            messages: [
              {
                date: new Date().toISOString().split('T')[0],
                charMsgInfos: [],
              },
            ],
          },
        ]
      }

      vm.groupToUser = vm.userList.filter(f => {
        return f.userAccount == user
      })[0]
      if (!vm.groupToUser) {
        // let findUser = await vm.getAnGroup(user)
        let findUser = await vm.getAnGroup(vm.fromUser, user)
        vm.groupToUser = findUser
      }

      // 確保 openGroupChat 屬性存在，如果 API 沒有回傳則使用預設值
      if (vm.groupToUser && vm.groupToUser.openGroupChat === undefined) {
        vm.groupToUser.openGroupChat = true // 預設為開啟
      }

      if (vm.panel != 'groupChat') {
        vm.panel = 'groupChat'
      }

      if (this.device == 'mobile') {
        this.dialogMessageVisible = true
      }

      vm.chatLoading = true

      // 建立聊天室並標示訊息已讀
      console.log('selectedGroup user', user)
      console.log('selectedGroup fromUser', vm.fromUser)
      // 確保群組 ID 格式一致
      // const groupId = `GroupChat_${vm.groupToUser.userID}`
      const groupId = user
      console.log('確保群組 ID 格式一致 vm.groupToUser.userID', vm.groupToUser.userID)
      const payload = { from: vm.fromUser, to: [groupId], isFromAppClient: false }
      console.log('群組註冊 payload:', payload)
      markMessageAsRead(payload)
        .then(async response => {
          await this.getGroupMessageList()
          // response.data 為完整群聊對話紀錄
          vm.groupChatList = response.data // <--- 塞到 groupChatList
          console.log('Group chat list loaded:', vm.groupChatList)

          // 確保至少有一個空的訊息日期結構 20250805 修復undefined錯誤
          if (vm.groupChatList.length > 0) {
            // 檢查第一個元素是否存在且有messages屬性
            if (!vm.groupChatList[0]) {
              vm.groupChatList[0] = { messages: [] }
            }
            if (!vm.groupChatList[0].messages) {
              vm.groupChatList[0].messages = []
            }
            // 如果messages是空陣列，添加今天的結構
            if (vm.groupChatList[0].messages.length === 0) {
              const today = new Date().toISOString().split('T')[0]
              vm.groupChatList[0].messages.push({
                date: today,
                charMsgInfos: [],
              })
              console.log('Created empty message structure for today')
            }
          } else {
            // 如果沒有任何訊息，創建預設結構
            vm.groupChatList = [
              {
                messages: [
                  {
                    date: new Date().toISOString().split('T')[0],
                    charMsgInfos: [],
                  },
                ],
              },
            ]
          }

          vm.chatLoading = false

          // 聊天視窗向底部
          setTimeout(() => {
            vm.updateScrollTop()
          }, 500)
        })
        .catch(error => {
          console.error('selectedGroup error:', error)
          vm.chatLoading = false
          // 發生錯誤時也要確保有基本結構
          vm.groupChatList = [
            {
              messages: [
                {
                  date: new Date().toISOString().split('T')[0],
                  charMsgInfos: [],
                },
              ],
            },
          ]
        })
    },
    // 進入討論區 20250805
    async enterDiscussion() {
      const vm = this

      if (vm.panel != 'discussionChat') {
        vm.panel = 'discussionChat'
      }

      if (this.device == 'mobile') {
        this.dialogMessageVisible = true
      }

      vm.discussionChatLoading = true

      // 重新檢查討論區連線，避免初始化時 agencyCode 尚未載入
      const agencyCode = vm.agencyCode || 'DEFAULT'
      if (
        !vm.discussionChatConnection ||
        vm.discussionChatConnection === 'AgencyChat_' ||
        vm.discussionChatConnection.includes('undefined')
      ) {
        vm.discussionChatConnection = `AgencyChat_${agencyCode}`
        console.log('重新設定討論區連線:', vm.discussionChatConnection)
      }

      // 確保 groupToUser 有設定，討論區需要使用 groupToUser.userID 來發送訊息
      if (!vm.groupToUser || !vm.groupToUser.userID) {
        // 直接使用當前用戶資訊作為 groupToUser
        const currentUserInfo = vm.$store.getters.userInfo
        vm.groupToUser = {
          userID: currentUserInfo.userID || currentUserInfo.id || vm.fromUser,
          userAccount: currentUserInfo.userAccount || vm.fromUser,
          userName: currentUserInfo.userName || currentUserInfo.name || vm.fromUser,
        }
        console.log('討論區設定 groupToUser:', vm.groupToUser)
        console.log('當前用戶資訊:', currentUserInfo)
      }

      // 初始化討論區聊天列表
      await vm.getDiscussionMessageList()

      vm.discussionChatLoading = false

      // 聊天視窗向底部
      setTimeout(() => {
        vm.updateScrollTop()
      }, 500)
    },
    obDialogClosed() {
      this.chatList = []
      this.toUser = {}
      this.currentCharMessages = []

      this.groupChatList = [
        {
          messages: [
            {
              date: new Date().toISOString().split('T')[0],
              charMsgInfos: [],
            },
          ],
        },
      ]
      this.groupToUser = {}
      this.currentGroupCharMessages = []

      // 清理討論區狀態 20250805
      this.discussionChatList = [
        {
          messages: [
            {
              date: new Date().toISOString().split('T')[0],
              charMsgInfos: [],
            },
          ],
        },
      ]
      this.currentDiscussionMessages = []
      this.discussionMsg = ''
    },
    sendMsg() {
      const vm = this
      console.log('發送訊息', this.msg, this.panel, this.toUser)
      if (this.panel === 'chat') {
        if (!this.msg.trim()) {
          return
        }
        this.msgkey = _uuid()
        const newMsg = {
          chatType: 1,
          from: this.fromUser,
          guid: this.msgkey,
          isRead: false,
          msg: this.msg,
          time: '',
          to: [this.toUser.userAccount],
          type: 1,
        }
        vm.appendMegToView(newMsg, 'chat')
        this.updateScrollTop()
        this.$socket.send(newMsg)
        vm.msg = ''
      } else if (this.panel === 'groupChat') {
        if (!this.groupMsg.trim()) return

        // 檢查群組聊天是否開啟
        if (!this.groupToUser.openGroupChat) {
          this.$message.warning('群組聊天已關閉，無法發送訊息')
          return
        }

        console.log('發送群組訊息this.groupToUser', this.groupToUser)
        console.log('發送群組訊息this.fromUser', this.fromUser)
        const travelID = this.selectedGroupUser.replace('GroupChat_', '')
        this.msgkey = Date.now() * 1000 + Math.floor(Math.random() * 1000000)
        const newMsg = {
          chatType: 1,
          // from: this.fromUser, // ex:a0002
          from: this.groupToUser.userID, // ex:189
          guid: this.msgkey,
          isRead: false,
          msg: this.groupMsg,
          time: '',
          travelID: travelID, // 旅行團 ID
          // to: ['GroupChat_' + this.groupToUser.userID],
          to: [travelID],
          type: 1,
        }
        console.log('發送群組文字訊息:', newMsg)
        this.appendMegToView(newMsg, 'group')
        this.$socketGroup.send(newMsg)
        vm.groupMsg = ''
      } else if (this.panel === 'discussionChat') {
        // 討論區訊息發送 20250805
        if (!this.discussionMsg.trim()) return

        // 檢查討論區是否開啟
        if (!this.discussionChatSwitch) {
          this.$message.warning('討論區已關閉，無法發送訊息')
          return
        }

        // 確保必要的資料存在
        if (!this.groupToUser || !this.groupToUser.userID) {
          this.$message.error('發送失敗：用戶資訊不完整')
          console.error('討論區發送失敗: groupToUser 不存在', this.groupToUser)
          return
        }

        if (!this.discussionChatConnection) {
          this.$message.error('發送失敗：討論區連線未初始化')
          console.error(
            '討論區發送失敗: discussionChatConnection 為空',
            this.discussionChatConnection
          )
          return
        }

        const agencyCode = this.agencyCode || 'DEFAULT'
        console.log('發送討論區訊息:', this.discussionMsg)
        console.log('討論區連線:', this.discussionChatConnection)
        console.log('討論區agencyCode:', agencyCode)
        console.log('討論區this.groupToUser:', this.groupToUser)

        this.msgkey = Date.now() * 1000 + Math.floor(Math.random() * 1000000)
        const newMsg = {
          chatType: 1,
          from: parseInt(this.groupToUser.userID) || this.groupToUser.userID,
          guid: this.msgkey,
          isRead: false,
          msg: this.discussionMsg,
          time: '',
          // to: [this.discussionChatConnection], // 使用正確的討論區連線，不是 [0]
          to: [0], // 使用正確的討論區連線，不是 [0]
          type: 1,
          agencyCode: agencyCode, // 傳送討論區的 agencyCode
        }
        console.log('發送討論區文字訊息:', newMsg)
        this.appendMegToView(newMsg, 'discussion')
        // 這裡可能需要使用專門的討論區socket連線，暫時使用群組socket
        this.$socketGroup.send(newMsg)
        vm.discussionMsg = ''
      }
    },
    sendFileMsg(file) {
      const vm = this

      if (this.panel === 'chat') {
        // 要判斷已讀，要知道對方是不是正在我的聊天視窗
        this.msgkey = _uuid()
        const newMsg = {
          chatType: 2, // 聊天內容類型 1文字 2圖片 3檔案
          from: this.fromUser, // 發送方
          guid: this.msgkey, // guid訊息識別碼
          isRead: false, // 是否已讀
          msg: '', // 聊天內容文字
          time: '', // 聊天時間
          to: [this.toUser.userAccount], // 傳送對像
          type: 1, // 傳送類型 1聊天 2通知..
          fileInfo: file,
        }

        // 添加至畫面
        vm.appendMegToView(newMsg, 'chat')

        // 聊天視窗向底部
        this.updateScrollTop()
        this.$socket.send(newMsg)
        vm.msg = ''
      } else if (this.panel === 'groupChat') {
        // 檢查群組聊天是否開啟
        if (!this.groupToUser.openGroupChat) {
          this.$message.warning('群組聊天已關閉，無法上傳檔案')
          return
        }

        // 要判斷已讀，要知道對方是不是正在我的聊天視窗
        const travelID = this.selectedGroupUser.replace('GroupChat_', '')
        this.msgkey = Date.now() * 1000 + Math.floor(Math.random() * 1000000)
        const newMsg = {
          chatType: 2, // 聊天內容類型 1文字 2圖片 3檔案
          // from: this.fromUser, // 發送方
          from: this.groupToUser.userID, // 強制使用 groupToUser.userID，與文字訊息保持一致
          guid: this.msgkey, // guid訊息識別碼
          isRead: false, // 是否已讀
          msg: '', // 聊天內容文字
          time: '', // 聊天時間
          travelID: travelID, // 旅行團 ID，群聊後端依此決定收件者
          to: [travelID], // 傳送對像需與群聊文字訊息一致，供接收端歸類目前群組
          type: 1, // 傳送類型 1聊天 2通知..
          fileInfo: file,
        }

        // 如果檔案沒有 URL，可能是 base64 格式，先嘗試使用 base64 作為臨時顯示
        if (file && !file.url && file.base64) {
          newMsg.fileInfo = {
            ...file,
            url: `data:image/png;base64,${file.base64}`,
          }
        }

        this.appendMegToView(newMsg, 'group')
        this.$socketGroup.send(newMsg)
        vm.groupMsg = ''
      } else if (this.panel === 'discussionChat') {
        // 討論區檔案發送 20250805

        // 檢查討論區是否開啟
        if (!this.discussionChatSwitch) {
          this.$message.warning('討論區已關閉，無法上傳檔案')
          return
        }

        this.msgkey = Date.now() * 1000 + Math.floor(Math.random() * 1000000)
        const newMsg = {
          chatType: 2, // 聊天內容類型 1文字 2圖片 3檔案
          from: this.groupToUser.userID, // 發送方，與討論區文字訊息保持一致
          guid: this.msgkey, // guid訊息識別碼
          isRead: false, // 是否已讀
          msg: '', // 聊天內容文字
          time: '', // 聊天時間
          to: [this.discussionChatConnection], // 討論區固定連線
          type: 1, // 傳送類型 1聊天 2通知..
          fileInfo: file,
        }

        // 如果檔案沒有 URL，可能是 base64 格式，先嘗試使用 base64 作為臨時顯示
        if (file && !file.url && file.base64) {
          newMsg.fileInfo = {
            ...file,
            url: `data:image/png;base64,${file.base64}`,
          }
        }

        console.log('發送討論區檔案:', newMsg)
        this.appendMegToView(newMsg, 'discussion')
        // 這裡可能需要使用專門的討論區socket連線，暫時使用群組socket
        this.$socketGroup.send(newMsg)
        vm.discussionMsg = ''
      }
    },
    // 團體群聊：點選貼圖後轉為 base64，複用 sendFileMsg 走既有的圖片訊息流程
    async sendSticker(sticker) {
      // 邊界防護：載入中 / 群聊已關閉 / 前一張仍在送 → 直接忽略，避免連發或壞狀態送出
      if (this.chatLoading || !this.groupToUser.openGroupChat || this.stickerSending) {
        return
      }
      this.stickerSending = true
      try {
        const resp = await fetch(sticker.url)
        // fetch 對 4xx/5xx 不會 reject，需自行檢查；否則會把錯誤頁內容當貼圖送進整個群組
        if (!resp.ok) {
          throw new Error('sticker fetch failed: ' + resp.status)
        }
        const blob = await resp.blob()
        const base64 = await convertFileToBase64(blob)
        this.sendFileMsg({ fileName: sticker.name, base64 })
      } catch (error) {
        console.error('貼圖發送失敗:', error)
        this.$message.error('貼圖發送失敗，請稍後再試')
      } finally {
        this.stickerSending = false
        this.stickerPopoverVisible = false
      }
    },
    // 討論區：點選貼圖後轉為 base64，複用 sendFileMsg 走既有的討論區圖片訊息流程（panel 須在 discussionChat）
    async sendDiscussionSticker(sticker) {
      // 邊界防護：載入中 / 討論區已關閉 / 前一張仍在送 → 直接忽略，避免連發或壞狀態送出
      if (this.discussionChatLoading || !this.discussionChatSwitch || this.stickerSending) {
        return
      }
      this.stickerSending = true
      try {
        const resp = await fetch(sticker.url)
        // fetch 對 4xx/5xx 不會 reject，需自行檢查；否則會把錯誤頁內容當貼圖送進討論區
        if (!resp.ok) {
          throw new Error('sticker fetch failed: ' + resp.status)
        }
        const blob = await resp.blob()
        const base64 = await convertFileToBase64(blob)
        this.sendFileMsg({ fileName: sticker.name, base64 })
      } catch (error) {
        console.error('討論區貼圖發送失敗:', error)
        this.$message.error('貼圖發送失敗，請稍後再試')
      } finally {
        this.stickerSending = false
        this.discussionStickerPopoverVisible = false
      }
    },
    async handleGetMessage(msg) {
      const vm = this
      const res = JSON.parse(msg.data)

      console.log('收到訊息')
      switch (res.type) {
        case 1:
          vm.markMessageAsTime(res.guid, res.time, res.fileInfo)
          break
        case 2: // 通知
          break
        case 3: // 聊天已接收確認 callback 收到訊息方type=4要回callback
          // 代表傳送方和目前開啟的聊天室窗是同一個帳號 可以回覆已讀
          const req = res
          if (res.from == vm.toUser.userAccount) {
            // 添加至畫面
            req.type = 4
            req.from = this.fromUser
            req.to = [this.toUser.userAccount]
            const append = JSON.parse(JSON.stringify(req))
            append.from = req.to[0]
            append.to = [req.from]
            vm.appendMegToView(append, 'chat')
            // alert("畫面focUs可以添加訊息");
            // alert("我收到訊息了，告知對方可以已讀了");
          } else {
            // alert("有人傳給我 但我沒有看 跟對方說沒有正在看");
            // 不在目前對話視窗 重新取得取得聊天通知筆數(簡易資料)
            req.type = 5
            // let f = res.to[0];
            // req.to = [res.from];
            // req.from = f;
            //debugger;
          }
          this.$socket.send(req)
          break
        case 4: // 已讀
          // alert("對方打開我跟我的對話框，所以可以改為已讀");
          // 標示已讀
          //可以用guid去找出那一條訊息標是已讀，這邊是把所有跟對方對話的訊息中 未讀的都改已讀
          vm.markMessageAsRead()
          break
        case 5: // 對方未即時接收
          // alert("對方未即時接收");
          break
        case 20:
          break
        case 21: // 取得聊天通知筆數(簡易資料)
          break
        case 500: // 錯誤訊息
          this.$message({
            message: res.msg,
            type: 'danger',
          })
          break
        default:
          break
      }

      // 只有處理個人聊天相關的訊息時才需要更新個人聊天列表
      // 避免在群組聊天時因為沒有個人聊天而被切換到好友列表
      if (vm.panel === 'chat' || res.type === 21) {
        await vm.getDirectMessages()
      }
    },
    async handleGetGroupMessage(msg) {
      console.log('=== 收到群組訊息 ===', msg)
      const vm = this
      const res = JSON.parse(msg.data)
      console.log('群組訊息內容:', res)
      console.log('當前用戶:', vm.fromUser)
      console.log('當前選擇的群組:', vm.groupToUser)

      // 判斷是討論區訊息還是群組聊天訊息 20250806
      const isDiscussionMessage = res.travelID === null && res.agencyCode
      const isGroupChatMessage = res.travelID && !res.agencyCode

      console.log('是否為討論區訊息:', isDiscussionMessage)
      console.log('是否為群組聊天訊息:', isGroupChatMessage)

      switch (res.type) {
        case 1:
          vm.markMessageAsTime(res.guid, res.time, res.fileInfo)
          break
        case 2: // 通知
          break
        case 3: // 聊天已接收確認 callback 收到訊息方type=4要回callback
          if (isDiscussionMessage) {
            // 處理討論區訊息 20250806
            console.log('處理討論區訊息:', res)

            // 檢查是否為當前討論區且用戶正在討論區頁面
            const isCurrentDiscussion = vm.panel === 'discussionChat'
            console.log('是否為當前討論區:', isCurrentDiscussion)

            if (isCurrentDiscussion) {
              // 檢查是否是自己發送的訊息
              const isOwnMessage =
                res.from === vm.fromUser || res.from == (vm.groupToUser && vm.groupToUser.userID)
              console.log('討論區是否為自己的訊息:', isOwnMessage)

              if (!isOwnMessage) {
                // 這是其他人發送給討論區的訊息，需要添加到畫面
                console.log('Adding discussion message from:', res.from)
                vm.appendMegToView(res, 'discussion')

                // 回覆確認收到訊息
                const confirmMsg = {
                  ...res,
                  type: 4,
                  from: vm.fromUser,
                  to: [res.from],
                }
                vm.$socketGroup.send(confirmMsg)
              } else {
                console.log('Own discussion message, skip adding to view')
              }
            } else {
              // 不在討論區頁面，發送未即時接收回應
              console.log('Not in discussion chat, sending type 5')
              const req = { ...res, type: 5 }
              vm.$socketGroup.send(req)
            }
          } else if (isGroupChatMessage) {
            // 原有的群組聊天邏輯 20250806
            console.log('處理群組聊天訊息:', res)
            // 檢查是否是發送給目前開啟的群組聊天室
            console.log('檢查群組訊息目標:', res.to)
            console.log('當前群組用戶:', vm.groupToUser)
            console.log('res.from:', res.from)
            console.log('vm.fromUser:', vm.fromUser)
            console.log(
              'vm.groupToUser.userID:',
              vm.groupToUser ? vm.groupToUser.userID : 'undefined'
            )
            console.log('selectedGroupUser:', vm.selectedGroupUser)

            // 檢查多種可能的群組ID匹配方式
            const possibleGroupIds = []
            if (vm.groupToUser) {
              possibleGroupIds.push(vm.groupToUser.userID.toString())
              possibleGroupIds.push(vm.groupToUser.userAccount)
              if (vm.selectedGroupUser) {
                possibleGroupIds.push(vm.selectedGroupUser)
                possibleGroupIds.push(vm.selectedGroupUser.replace('GroupChat_', ''))
              }
            }

            console.log('可能的群組ID:', possibleGroupIds)

            // 檢查是否為當前群組的訊息
            const isCurrentGroupChat =
              res.to &&
              res.to.some(to => {
                return possibleGroupIds.some(
                  groupId =>
                    to == groupId || to === groupId || to.includes(groupId) || groupId.includes(to)
                )
              })

            console.log('是否為當前群組訊息:', isCurrentGroupChat)

            if (isCurrentGroupChat) {
              // 檢查是否是自己發送的訊息
              const isOwnMessage = res.from === vm.fromUser || res.from == vm.groupToUser.userID
              console.log('是否為自己的訊息:', isOwnMessage)

              if (!isOwnMessage) {
                // 這是其他人發送給目前群組的訊息，需要添加到畫面
                console.log('Adding group message from:', res.from)
                vm.appendMegToView(res, 'group')

                // 只有在 type 3 時才回覆確認收到訊息
                if (res.type === 3) {
                  const confirmMsg = {
                    ...res,
                    type: 4,
                    from: vm.fromUser,
                    to: [res.from],
                  }
                  vm.$socketGroup.send(confirmMsg)
                }
              } else {
                // 這是自己發送的訊息，不需要額外處理
                console.log('Own message, skip adding to view')
              }
            } else {
              // 不是目前群組的訊息
              if (res.type === 3) {
                console.log('Not current group message, sending type 5')
                const req = { ...res, type: 5 }
                vm.$socketGroup.send(req)
              } else {
                console.log('Type 5 message not for current group, ignoring')
              }
            }
          }
          break
        case 4: // 已讀
          // 標示已讀
          vm.markMessageAsRead()
          break
        case 5: // 對方未即時接收 - 但我們也要檢查是否為當前群組
        // alert("對方未即時接收");
        case 20:
          break
        case 21: // 取得聊天通知筆數(簡易資料)
          break
        case 71: // 移出討論區回應/系統訊息
          console.log('收到移出討論區回應/系統訊息:', res)

          // 檢查是否為討論區相關的系統訊息且有 chatType
          if (res.chatType === 5 && isDiscussionMessage) {
            console.log('處理移出討論區系統訊息:', res)

            // 檢查是否為當前討論區且用戶正在討論區頁面
            const isCurrentDiscussion = vm.panel === 'discussionChat'
            console.log('是否為當前討論區:', isCurrentDiscussion)

            if (isCurrentDiscussion) {
              // 將系統訊息添加到討論區
              console.log('Adding discussion system message:', res.msg)
              vm.appendMegToView(res, 'discussion')
            }
          }
          break
        case 81: // 黑名單回應
          console.log('收到黑名單回應:', res)
          // 這是黑名單的回應，不需要特別處理
          break
        case 500: // 錯誤訊息
          this.$message({
            message: res.msg,
            type: 'danger',
          })
          break
        default:
          console.log('未處理的群組訊息類型:', res.type, res)
          break
      }

      // 只有在特定情況下才重新載入群組訊息列表
      // 避免在處理討論區訊息或特殊回應時造成畫面跳轉
      const shouldReloadGroupMessages =
        res.type === 3 && isGroupChatMessage && vm.panel === 'groupChat'

      console.log('是否需要重新載入群組訊息:', shouldReloadGroupMessages)
      console.log('當前面板:', vm.panel)
      console.log('訊息類型:', res.type)

      if (shouldReloadGroupMessages) {
        // 只有在收到群組聊天訊息且正在群組聊天頁面時才重新載入
        console.log('重新載入群組訊息列表:', res)
        await vm.getGroupMessageList()
      }
    },
    appendMegToView(newMsg, type) {
      const vm = this

      if (type === 'chat') {
        if (vm.currentCharMessages.length > 0) {
          const currentChat = vm.currentCharMessages[vm.currentCharMessages.length - 1]
          if (!currentChat.charMsgInfos) currentChat.charMsgInfos = []
          currentChat.charMsgInfos.push(newMsg)
        } else {
          alert('未取得聊天紀錄')
        }
      } else if (type === 'group') {
        if (vm.groupChatList.length > 0) {
          // 確保第一個元素和messages屬性存在 20250805 修復undefined錯誤
          if (!vm.groupChatList[0]) {
            vm.groupChatList[0] = { messages: [] }
          }
          if (!vm.groupChatList[0].messages) {
            vm.groupChatList[0].messages = []
          }

          if (vm.groupChatList[0].messages.length > 0) {
            const currentGroup =
              vm.groupChatList[0].messages[vm.groupChatList[0].messages.length - 1]
            if (!currentGroup.charMsgInfos) {
              vm.$set(currentGroup, 'charMsgInfos', [])
            }

            // 使用 Vue.set 來確保響應式更新
            const newCharMsgInfos = [...currentGroup.charMsgInfos, newMsg]
            vm.$set(currentGroup, 'charMsgInfos', newCharMsgInfos)

            // 強制觸發整個 groupChatList 的更新
            vm.$set(vm.groupChatList, 0, { ...vm.groupChatList[0] })

            // 使用 nextTick 確保 DOM 更新完成後再滾動
            vm.$nextTick(() => {
              vm.updateScrollTop()
            })
          } else {
            // 如果沒有訊息記錄，創建一個今天的記錄
            const today = new Date().toISOString().split('T')[0]
            vm.groupChatList[0].messages.push({
              date: today,
              charMsgInfos: [newMsg],
            })
          }
        } else {
          alert('未取得群組聊天紀錄')
        }
      } else if (type === 'discussion') {
        // 討論區訊息添加處理 20250805
        if (vm.discussionChatList.length > 0) {
          // 確保第一個元素和messages屬性存在 20250805 修復undefined錯誤
          if (!vm.discussionChatList[0]) {
            vm.discussionChatList[0] = { messages: [] }
          }
          if (!vm.discussionChatList[0].messages) {
            vm.discussionChatList[0].messages = []
          }

          if (vm.discussionChatList[0].messages.length > 0) {
            const currentDiscussion =
              vm.discussionChatList[0].messages[vm.discussionChatList[0].messages.length - 1]
            if (!currentDiscussion.charMsgInfos) {
              vm.$set(currentDiscussion, 'charMsgInfos', [])
            }

            // 使用 Vue.set 來確保響應式更新
            const newCharMsgInfos = [...currentDiscussion.charMsgInfos, newMsg]
            vm.$set(currentDiscussion, 'charMsgInfos', newCharMsgInfos)

            // 強制觸發整個 discussionChatList 的更新
            vm.$set(vm.discussionChatList, 0, { ...vm.discussionChatList[0] })

            // 使用 nextTick 確保 DOM 更新完成後再滾動
            vm.$nextTick(() => {
              vm.updateScrollTop()
            })
          } else {
            // 如果沒有訊息記錄，創建一個今天的記錄
            const today = new Date().toISOString().split('T')[0]
            vm.discussionChatList[0].messages.push({
              date: today,
              charMsgInfos: [newMsg],
            })
          }
        } else {
          alert('未取得討論區聊天紀錄')
        }
      }

      if (type === 'chat' || type === 'discussion') {
        vm.updateScrollTop()
      }
    },
    markMessageAsTime(guid, time, fileInfo) {
      const vm = this

      // 處理個人聊天
      if (vm.currentCharMessages.length > 0) {
        vm.currentCharMessages.forEach(m => {
          m.charMsgInfos.forEach(info => {
            if (info.guid == guid) {
              info.time = time
              if (fileInfo) info.fileInfo = fileInfo
            }
          })
        })
      }

      // 處理群組聊天 - 直接操作 groupChatList
      if (vm.groupChatList.length > 0 && vm.groupChatList[0].messages.length > 0) {
        vm.groupChatList[0].messages.forEach(m => {
          if (m.charMsgInfos) {
            m.charMsgInfos.forEach(info => {
              if (info.guid == guid) {
                info.time = time
                if (fileInfo) info.fileInfo = fileInfo
                // 強制觸發更新
                // vm.$forceUpdate()
              }
            })
          }
        })
      }

      // 處理討論區聊天 - 直接操作 discussionChatList 20250805
      if (vm.discussionChatList.length > 0 && vm.discussionChatList[0].messages.length > 0) {
        vm.discussionChatList[0].messages.forEach(m => {
          if (m.charMsgInfos) {
            m.charMsgInfos.forEach(info => {
              if (info.guid == guid) {
                info.time = time
                if (fileInfo) info.fileInfo = fileInfo
              }
            })
          }
        })
      }
    },
    markMessageAsRead() {
      const vm = this
      // 處理個人聊天已讀狀態
      if (vm.currentCharMessages.length > 0) {
        vm.currentCharMessages.forEach(m => {
          m.charMsgInfos.forEach(info => {
            if (info.isRead == false) {
              info.isRead = true
            }
          })
        })
      }

      // 處理群組聊天已讀狀態 - 直接操作 groupChatList
      if (vm.groupChatList.length > 0 && vm.groupChatList[0].messages.length > 0) {
        vm.groupChatList[0].messages.forEach(m => {
          if (m.charMsgInfos) {
            m.charMsgInfos.forEach(info => {
              if (info.isRead == false) {
                info.isRead = true
              }
            })
          }
        })
      }

      // 處理討論區聊天已讀狀態 - 直接操作 discussionChatList 20250805
      if (vm.discussionChatList.length > 0 && vm.discussionChatList[0].messages.length > 0) {
        vm.discussionChatList[0].messages.forEach(m => {
          if (m.charMsgInfos) {
            m.charMsgInfos.forEach(info => {
              if (info.isRead == false) {
                info.isRead = true
              }
            })
          }
        })
      }
    },
    updateScrollTop() {
      // 使用setTimeout確保DOM已更新
      setTimeout(() => {
        const chatWindows = document.getElementsByClassName('chat-window')
        if (chatWindows.length > 0) {
          // 找到目前顯示的聊天視窗
          for (let i = 0; i < chatWindows.length; i++) {
            const chatBody = chatWindows[i].querySelector('.el-card__body')
            if (chatBody && chatBody.offsetParent !== null) {
              // 檢查元素是否可見
              chatBody.scrollTop = chatBody.scrollHeight
            }
          }
        }
      }, 100)
    },
    cutText(s) {
      return s.length > 15 ? s.substring(0, 12) + '...' : s
    },
    async handleOpenGroupChatChange(value) {
      const vm = this
      // console.log('群組聊天開關變更:', value)
      // console.log('群組資訊:', vm.groupToUser)
      // console.log('群組 userID:', vm.groupToUser.userID)
      // console.log('群組 vm.fromUser:', vm.fromUser)
      if (!vm.groupToUser || !vm.groupToUser.userID) {
        vm.$message.error('請先選擇群組')
        return
      }

      vm.switchLoading = true
      try {
        // 調用 setSwitchGroupChat API
        const agencyCode = vm.fromUser
        const userId = vm.groupToUser.userID
        const travelId = parseInt(vm.groupToUser.userAccount.replace('GroupChat_', ''))
        const switchGroupChat = value

        console.log('調用 setSwitchGroupChat API，參數:', {
          agencyCode,
          userId,
          travelId,
          switchGroupChat,
        })
        var isSuccess = await setSwitchGroupChat({ agencyCode, userId, travelId, switchGroupChat })

        if (!isSuccess) {
          vm.$message.error(`群組聊天${value ? '開啟' : '關閉'}失敗`)
        } else {
          vm.$message.success(`群組聊天已${value ? '開啟' : '關閉'}`)
        }

        // 如果需要重新載入群組資訊
        // await vm.getAnGroup(vm.fromUser, vm.selectedGroupUser)
      } catch (error) {
        console.error('設定群組聊天開關失敗:', error)
        vm.$message.error('設定失敗，請稍後再試')
        // 恢復開關狀態
        vm.groupToUser.openGroupChat = !value
      } finally {
        vm.switchLoading = false
      }
    },
    // 處理討論區開關變更
    async handleOpenDiscussionChatChange(value) {
      const vm = this

      // 防止重複調用
      if (vm.isUpdatingDiscussionSwitch) {
        console.log('已在處理討論區開關變更，跳過重複調用')
        return
      }

      console.log('討論區開關變更:', value)

      // 設置標記防止重複調用
      vm.isUpdatingDiscussionSwitch = true

      // 立即更新本地狀態以提供即時反饋
      const originalValue = vm.localDiscussionChatSwitch
      vm.localDiscussionChatSwitch = value

      vm.switchLoading = true
      try {
        // 調用 setSwitchAgencyChat API
        const agencyCode = vm.agencyCode || vm.fromUser
        const switchAgencyChat = value

        console.log('調用 setSwitchAgencyChat API，參數:', {
          agencyCode,
          switchAgencyChat,
        })

        var isSuccess = await setSwitchAgencyChat({ agencyCode, switchAgencyChat })

        if (!isSuccess) {
          vm.$message.error(`討論區${value ? '開啟' : '關閉'}失敗`)
          // API失敗時恢復本地狀態
          vm.localDiscussionChatSwitch = originalValue
        } else {
          vm.$message.success(`討論區已${value ? '開啟' : '關閉'}`)
          // API成功時更新 store 中的 openAgencyChat 狀態
          vm.$store.dispatch('user/updateUserInfo', {
            ...vm.$store.getters.userInfo,
            openAgencyChat: value,
          })
          // 同步本地狀態
          vm.localDiscussionChatSwitch = value
        }
      } catch (error) {
        console.error('設定討論區開關失敗:', error)
        vm.$message.error('設定失敗，請稍後再試')
        // 錯誤時恢復本地狀態
        vm.localDiscussionChatSwitch = originalValue
      } finally {
        vm.switchLoading = false
        // 清除標記
        vm.isUpdatingDiscussionSwitch = false
      }
    },
    // 顯示討論區右鍵選單
    showDiscussionContextMenu(event, message) {
      console.log('右鍵點擊討論區訊息:', message)

      // 只對其他人的訊息顯示右鍵選單
      if (
        message.from === this.fromUser ||
        message.from == (this.groupToUser && this.groupToUser.userID)
      ) {
        return
      }

      this.selectedMessage = message
      this.contextMenuX = event.clientX
      this.contextMenuY = event.clientY
      this.showContextMenu = true

      // 防止右鍵選單超出視窗邊界
      this.$nextTick(() => {
        const menu = this.$refs.contextMenu
        if (menu) {
          const rect = menu.getBoundingClientRect()
          const windowWidth = window.innerWidth
          const windowHeight = window.innerHeight

          if (rect.right > windowWidth) {
            this.contextMenuX = windowWidth - rect.width - 10
          }
          if (rect.bottom > windowHeight) {
            this.contextMenuY = windowHeight - rect.height - 10
          }
        }
      })
    },
    // 隱藏右鍵選單
    hideContextMenu() {
      this.showContextMenu = false
      this.selectedMessage = null
    },
    // 移出討論區
    removeFromDiscussion() {
      if (!this.selectedMessage) return

      console.log('移出討論區:', this.selectedMessage)

      // 取得目前旅行團ID（如果有的話）
      let travelID = 0
      if (this.groupToUser && this.groupToUser.userID) {
        travelID = this.groupToUser.userID
      }

      // ex. 將 this.selectedMessage.to[0] 格式 "AgencyChat_A00003" 轉換為 "A00003"
      const toUser = this.selectedMessage.to[0] || ''
      const toUserFormatted = toUser.replace('AgencyChat_', '')

      const newMsg = {
        chatType: this.groupToUser.chatType || 1, // 使用 groupToUser 的 chatType，默認為 1
        from: this.groupToUser.userID,
        guid: this.selectedMessage.guid,
        isRead: this.selectedMessage.isRead,
        msg: this.selectedMessage.msg,
        time: '',
        travelID: this.selectedMessage.travelID || travelID, // 使用選擇的訊息的 travelID 或默認值
        to: [this.selectedMessage.from], // 移出對象
        agencyCode: toUserFormatted || '', // 使用選擇的訊息的 agencyCode 或默認值
        type: 70, // 移出討論區
      }

      console.log('發送移出討論區訊息:', newMsg)
      this.$socketGroup.send(newMsg)

      this.hideContextMenu()
      this.$message.success('已將該用戶移出討論區')
    },
    // 加入黑名單
    addToBlacklist() {
      if (!this.selectedMessage) return

      console.log('加入黑名單:', this.selectedMessage)

      // 取得目前旅行團ID（如果有的話）
      let travelID = 0
      if (this.groupToUser && this.groupToUser.userID) {
        travelID = this.groupToUser.userID
      }

      // 生成新的 msgkey
      const msgkey = Date.now() * 1000 + Math.floor(Math.random() * 1000000)

      const newMsg = {
        chatType: 1,
        from: this.groupToUser.userID,
        guid: msgkey,
        isRead: false,
        msg: this.selectedMessage.msg,
        time: '',
        travelID: travelID,
        to: [travelID],
        type: 80, // 黑名單
      }

      console.log('發送黑名單訊息:', newMsg)
      this.$socketGroup.send(newMsg)

      this.hideContextMenu()
      this.$message.success('已將該用戶加入黑名單')
    },
  },
}
</script>

<style>
.messageDialog .el-dialog__body {
  height: 80% !important;
}

.full-height {
  position: relative;
  height: 100%;
}

.chat-container-from {
  position: relative;
  margin-bottom: 10px;
  /* height: 30px; */
}

.chat-content-form {
  font-size: 15px;
  display: inline-block;
  max-width: 80%;
  position: relative;
  /* background-color: #13ce66; */
  color: white;
  background-color: #fff8e0;
  color: #42443f;
  padding: 4px 8px;
  letter-spacing: 0.05em;
  line-height: 20px;
  width: auto;
  border-radius: 6px;
}

.chat-container-send {
  position: relative;
  margin-bottom: 10px;
  /* height: 30px; */
}

.chat-content-send {
  font-size: 15px;
  display: inline-block;
  max-width: 80%;
  position: relative;
  /* height: 30px; */
  margin-bottom: 3px;
  /* background-color: #ff4949; */
  /* color: white; */
  background-color: #f7f7f7;
  color: #42443f;
  padding: 4px 8px;
  letter-spacing: 0.05em;
  line-height: 20px;
  width: auto;
  border-radius: 6px;
  word-wrap: break-word;
  word-break: normal;
}

.chat-container-from .time-flag {
  bottom: 0px;
  position: absolute;
  font-size: 12px;
  color: #42443f;
  margin-left: 5px;
}

.chat-container-send .time-flag {
  top: 10px;
  font-size: 12px;
  color: #42443f;
  margin-right: 5px;
}

.el-card-define {
  position: relative;
  min-height: 100%;
  height: 100%;
}

.el-card-define >>> .el-card__body {
  position: relative;
  height: 100%;
}

.row-box {
  position: relative;
  height: 100% !important;
}

.el-input-group__append button.el-button {
  background: #42d885;
  border-color: #42d885;
  color: #ffffff;
}
/* 群聊 append 內同時有貼圖鈕 + 發送鈕。
   保留 Element 的 display:table-cell（不可覆寫，否則整組 input-group 跑版換行），
   僅：不換行 + 清除 Element 對 append 內 .el-button 的 margin:-10px -20px（造成疊圖），
   兩顆按鈕以 inline + vertical-align:middle 在同一行並排。 */
.group-sticker-input .el-input-group__append {
  padding: 0 8px;
  white-space: nowrap;
}
.group-sticker-input .el-input-group__append .el-button {
  margin: 0 0 0 4px;
  vertical-align: middle;
}
/* 討論區 append 內同時有貼圖鈕 + 發送鈕，比照群聊：不換行 + 清除 Element 負邊距 */
.discussion-sticker-input .el-input-group__append {
  padding: 0 8px;
  white-space: nowrap;
}
.discussion-sticker-input .el-input-group__append .el-button {
  margin: 0 0 0 4px;
  vertical-align: middle;
}

.chat-date {
  text-align: center;
  margin-bottom: 8px;
}

.read-flag {
  font-size: 5px;
  margin-right: 2px;
}

.el-tabs__content {
  position: relative;
  height: 95%;
}

/* 右鍵選單樣式 */
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
  min-width: 120px;
}

.context-menu-item {
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  transition: all 0.3s;
}

.context-menu-item:hover {
  background-color: #f5f7fa;
  color: #409eff;
}

.context-menu-item:not(:last-child) {
  border-bottom: 1px solid #f0f0f0;
}

/* 團體群聊貼圖 */
.sticker-trigger-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 4px;
  cursor: pointer;
  vertical-align: middle;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.sticker-trigger-btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.sticker-trigger-btn.is-disabled {
  cursor: not-allowed;
  opacity: 0.4;
  pointer-events: none;
}

.sticker-trigger-icon {
  width: 20px;
  height: 20px;
  pointer-events: none;
}

.sticker-panel {
  display: flex;
  flex-direction: column;
}

.sticker-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.sticker-item {
  width: 140px;
  height: 140px;
  object-fit: cover;
  cursor: pointer;
  border-radius: 8px;
  transition: transform 0.15s;
}

.sticker-item:hover {
  transform: scale(1.08);
}

.sticker-group-tabs {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.sticker-group-tab {
  width: 48px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  font-size: 24px;
  color: #909399;
  background-color: #f2f3f5;
}

.sticker-group-tab.is-active {
  background-color: #42d885;
  color: #ffffff;
}

/* 窄螢幕（手機）自適應：放大後的 540px 面板會超出手機螢幕，
   縮成貼合視窗寬度、貼圖填滿格子（來源為正方形，height:auto 維持方形），
   避免右排貼圖被切；桌機（>600px）不受影響、維持 2×(540/140px)。 */
@media (max-width: 600px) {
  .sticker-popover.el-popover {
    width: calc(100vw - 24px) !important;
    min-width: 0 !important;
    max-width: 540px !important;
    box-sizing: border-box;
  }
  .sticker-popover .sticker-grid {
    gap: 12px;
  }
  .sticker-popover .sticker-item {
    width: 100%;
    height: auto;
  }
}
</style>

<style scoped></style>
